import FTCBanner from "./FTCBanner"

export default FTCBanner
